import { AfterViewInit, ChangeDetectorRef, Component, DoCheck, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { SpecialCompbaser } from "../../../components/compbaser";
import {
    ExperienceLevelType,
    IAccessTable,
    IAppSettingsWrap,
    Id,
    IEffectTypeAny,
    IPlayerProps,
    IResource,
    ISceneBreadcrumb,
    ISceneItemPosition,
    ISceneTreeSliceResults,
    ISelectedSceneSceneId,
    IUser,
} from "../../../interfaces";
import { Lib } from "libs/Lib";
import { AppService } from "../../../services/app.service";
import { actionSceneBreadcrumbsClear, actionSceneJumpLinked, actionSelectedSceneId, actionSelectedSceneItemId, actionSetEditorMode, actionUpdateSceneItem } from "../../../store/actions/user.actions";
import { BlockLabels, IAdvancedEvents, IBlockLabelProp } from "../scene-blocks/block-constants";
import { buildComponentWrapperScene, compareIds, convertBooleanToNumbers, convertNumberToBoolean, getSceneItemPathCrumbs, isGroupItem, isHostDevOrLocal, isMimeTypeExists, isTruthy, mimeSwap, shortenString } from "../../../common";
import {
    faAnchor,
    faBell,
    faBolt,
    faCode,
    faCube,
    faHandPointer,
    faHdd,
    faObjectUngroup,
    faPlane,
    faPlugCircleCheck,
    faRandom,
    faReceipt,
    faRightFromBracket,
    faRobot,
    faWrench,
    IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import { getFontIcons } from "../../../common/get-icons";
import { Title } from "@angular/platform-browser";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { AccessService, ContainerService, LocalStoreService, SceneService, StoreSelectorsService } from "../../../services";
import { TranslocoService } from "@ngneat/transloco";
import { filter, map, mergeMap } from "rxjs/operators";
import { combineLatest, of } from "rxjs";
import { MatTabGroup } from "@angular/material/tabs";
import { MatDialog } from "@angular/material/dialog";
import { take } from "rxjs/operators";
import { MatDrawer, MatDrawerContainer } from "@angular/material/sidenav";
import { MatExpansionPanel } from "@angular/material/expansion";
import { TableDialogService } from "../../../services/table-dialog.service";
import { IButtonBar } from "../../../components/add-remove-bar/button-bar.component";
import { ExpressionBuilderDialogComponent } from "./expression-builder-dialog.component";
import { EventPickerDialogComponent } from "./event-picker-dialog.component";
import { MatTableDataSource } from "@angular/material/table";
import { SceneMimeTypes } from "../scene-blocks/mime-constants";
import { AiService } from "../../../services/ai/ai.service";
import * as _ from "lodash";

export type ITimelineViewMode = "animationMode" | "playlistMode" | "collectionMode" | "locationMode";

@Component({
    selector: "app-editor-editor",
    templateUrl: "./scene-editor.component.html",
    styleUrls: ["./scene-editor.component.scss"],
    animations: [
        trigger("fadeProperty", [
            state("void, hidden", style({ opacity: 0 })),
            state("visible", style({ opacity: 1 })),
            transition("* => visible", animate("1500ms cubic-bezier(0.0, 0.0, 0.2, 1)")),
            transition("* => hidden", animate("77ms cubic-bezier(0.4, 0.0, 1, 1)")),
        ]),
    ],
    standalone: false,
})
export class SceneEditorComponent extends SpecialCompbaser implements OnInit, AfterViewInit, DoCheck {
    @ViewChild("detailsTemplate", { static: true }) detailsTemplate!: TemplateRef<any>;
    @ViewChild("animationTemplate", { static: true }) animationTemplate!: TemplateRef<any>;
    @ViewChild("effectsTemplate", { static: true }) effectsTemplate!: TemplateRef<any>;

    // the top property panel (holds the selected block's form). Lazily rendered; we expand it on demand so a
    // block's table-list-input mounts and registers its "open in dialog" opener (see onMountRequest wiring).
    @ViewChild("propPanel") propPanel: MatExpansionPanel;
    @ViewChild("tabGroupAnimation") tabGroupAnimation: MatTabGroup;
    @ViewChild("sidenav") sidenav: MatDrawer;
    // the left toolbox drawer -- shows/hides with focused component-edit mode
    @ViewChild("toolboxDrawer") toolboxDrawer: MatDrawer;

    @ViewChild(MatDrawerContainer) drawerContainer!: MatDrawerContainer;

    readonly faWrench = faWrench;
    readonly faAnchor = faAnchor;
    readonly faPlugCircleCheck = faPlugCircleCheck;
    readonly faRandom = faRandom;
    readonly faObjectUngroup = faObjectUngroup;
    readonly faHandPointer = faHandPointer;
    readonly faHdd = faHdd;
    readonly faCode = faCode;
    readonly faReceipt = faReceipt;
    readonly faBell = faBell;
    readonly faBolt = faBolt;
    readonly faCube = faCube;
    readonly faRightFromBracket = faRightFromBracket;
    minimized = false;
    activeTemplate = "details";

    sceneItems: ISceneItemPosition[] = [];
    totalItemsAdded = 0;
    propertiesWidth = "285px";
    transitionExist = false;
    selectItemIndex = -1;
    propsMinimized = false;

    isHostDevOrLocal = false;
    panelOpenState = true;
    renderSceneContainer = false;
    selectedSceneId;
    showEffects = true;
    selectedSceneItemId: Id = "";
    blockName = "";
    showEvents = true;
    showPop: boolean = null;
    isBlockTransition = false;
    isBlockAdvEvents: IAdvancedEvents = null;
    isBlockAnimation = false;
    isDataProvider = false;
    isBlockBeacon = false;
    isBlockCollection = false;
    // slideshow-mode collections auto-advance; the touch/interactivity controls (hotkeys/idle/mouse-interrupt)
    // don't apply, so the touch panel is hidden for them.
    isCollectionSlideshow = false;
    isBlockEventsPremium = false;
    sceneData: IPlayerProps;
    resources: IResource[] = [];
    isSceneButNotNested = false;
    initEventsDataSource = new MatTableDataSource<any>([]);
    isNotNested = true;
    transitionsEnabled = false;
    // isAnchorSupport = false;
    sceneSlice: ISceneTreeSliceResults;
    blockJsonBased = false;
    blockIcon: IconDefinition;
    blockMimeName = "";
    blockVideoLinkName = "";
    videoHelp = false;
    isPlayerAssignable = false;
    ind = 1;
    visibility = "visible";
    viewMode: ITimelineViewMode;
    coreAppData: IAppSettingsWrap;
    user: IUser;
    accessConfig: IAccessTable;
    activeTabIndex = 1;
    multiple = false;
    scriptingMode = false;
    isFullFeatures;
    sceneMime = "";
    activeIds = [];

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;
    iotEnabled = "1";

    constructor(
        private title: Title,
        private route: ActivatedRoute,
        private localStoreService: LocalStoreService,
        protected containerService: ContainerService,
        private storeSelector: StoreSelectorsService,
        private accessService: AccessService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private translocoService: TranslocoService,
        private aiService: AiService,
        private sceneService: SceneService,
        private tableDialogService: TableDialogService,
        private appService: AppService,
        dialog: MatDialog,
    ) {
        super(dialog);
    }

    // The breadcrumb bar is hosted here (the whole scene editor) so it spans the full width and shows in
    // every mode (canvas, playlist timeline, etc.). Always visible; falls back to the current scene when
    // there is no drill-in trail. Click handling lives in SceneService.navigateToBreadcrumb.
    breadcrumbs: ISceneBreadcrumb[] = [];

    get displayBreadcrumbs(): ISceneBreadcrumb[] {
        // the real scene (not the component-edit wrapper) so the item path keeps its playlist nesting
        const scene = this.realScene || this.sceneData;
        const sceneId = scene?.Player?.$?.id;
        if (!sceneId) return [];
        const sceneLabel = scene.Player.$.label || 'Scene';
        // scene-level trail (nested-scene navigation), falling back to the current scene
        const trail = (this.breadcrumbs && this.breadcrumbs.length > 0)
            ? this.breadcrumbs.slice()
            : [{ sceneId, label: sceneLabel }];
        // the selected item's path within the current scene: scene > [playlist >] item.
        // Only shown once actually DRILLED IN to a component (focused component-edit / componentMode) - merely
        // selecting an item on the canvas must NOT append a crumb (the crumb reflects drill-in depth, not selection).
        // In group-edit the crumb tracks the GROUP (not the child being selected inside it), so "scene > Group"
        // stays stable while you click around its children.
        const crumbItemId = (this.componentMode && this.componentEditTarget?.groupEdit)
            ? this.componentEditTarget.componentId
            : this.selectedSceneItemId;
        const itemCrumbs = this.componentMode
            ? getSceneItemPathCrumbs(scene, crumbItemId, sceneId)
            : [];
        // drop consecutive duplicates (same scene + item): the trail's tail item can equal the derived
        // path head (e.g. a playlist crumb pushed into the trail + the same playlist from the item path).
        const combined = [...trail, ...itemCrumbs];
        return combined.filter((c, i) => {
            if (i === 0) return true;
            const prev = combined[i - 1];
            return !(String(prev.sceneId) === String(c.sceneId)
                && String(prev.sceneItemId || '') === String(c.sceneItemId || ''));
        });
    }

    // Publish the current drill depth (visible breadcrumb trail length - 1; 0 = root) so scene-builder can route
    // the editor zoom (root = persisted zoom, deeper levels = runtime zoom stack). displayBreadcrumbs already
    // unifies nested-scene navigation AND component/group drilling, so it is the single source of truth for depth.
    ngDoCheck(): void {
        // Only publish when the scene is resolved: displayBreadcrumbs returns [] transiently while realScene is
        // momentarily null during a re-render. Publishing depth 0 in that blip would make scene-builder wipe its
        // zoom stack. A resolved scene always yields length >= 1 (the fallback root crumb).
        const len = this.displayBreadcrumbs.length;
        if (len > 0) this.containerService.updateDrillDepth(len - 1);
    }

    navigateToBreadcrumb(index: number) {
        const crumbs = this.displayBreadcrumbs;
        const crumb = crumbs[index];
        if (!crumb) return;
        // crumbs within the manual trail get their trail index (so a click trims it); appended item-path
        // crumbs (within the current scene) get -1
        const trailLen = this.breadcrumbs?.length || 0;
        this.sceneService.goToBreadcrumb(crumb, index < trailLen ? index : -1);
    }

    // Middle-ellipsis a long crumb label so BOTH ends stay readable. Names often differ only at the tail
    // (e.g. "Sushi Restaurant_Timeline 2" vs "...Timeline 3"), so a plain end-ellipsis would hide exactly the
    // distinguishing part. Keeps the leading context + trailing suffix; the full name is in the tooltip.
    crumbLabel(label: string, max = 22): string {
        if (!label || label.length <= max) return label;
        const ellipsis = '…';
        const keep = max - ellipsis.length;
        const head = Math.ceil(keep / 2);
        const tail = Math.floor(keep / 2);
        return label.slice(0, head) + ellipsis + label.slice(label.length - tail);
    }

    // whether a crumb is truncated (so we only show the tooltip when there is something hidden)
    crumbTruncated(label: string, max = 22): boolean {
        return !!label && label.length > max;
    }

    // back is disabled when only the root crumb remains (nothing to step back to).
    get canGoBack(): boolean {
        return this.displayBreadcrumbs.length > 1;
    }

    // drill-in is enabled when the selected top-level item is a CONTAINER: a group / scene-embedding component
    // drills into that nested scene, a content/data-provider block (playlist, collection, json-player, ...) drills
    // into a focused component-edit. A leaf component (label, clock, ...) is not drillable - nothing sits below it.
    // Disabled while already in a focused component-edit (componentMode).
    get canDrillIn(): boolean {
        return !this.componentMode && this.sceneService.isDrillableItem(this.selectedSceneItemId);
    }

    // drill into the currently-selected item (nested scene, or focused component-edit for a plain component).
    drillIn() {
        this.sceneService.drillIntoItem(this.selectedSceneItemId);
    }

    // back: step one crumb back in the visible trail. Disabled (no-op) when only the root crumb
    // remains — it does NOT fall through to home.
    goBack() {
        const crumbs = this.displayBreadcrumbs;
        if (crumbs.length > 1) {
            this.navigateToBreadcrumb(crumbs.length - 2);
        }
    }

    // home: exit the scene editor back to the scene list (the home button now lives at the left of the
    // breadcrumb; mirrors the old scene-builder toolbar home button -> backSceneList()).
    goHome() {
        this.containerService.setMarkedTableRow(this.selectedSceneId);
        this.router.navigateByUrl('/editor/list');
    }

    // focused single-component edit: when active, the canvas renders ONLY the target component (an in-memory
    // wrapper scene whose id == the real scene id, so canvas edits write straight back to the nested component)
    // and the left toolbox is hidden. The property panel stays in its normal place.
    componentMode = false;
    // an aggregator/data-provider component being edited focused still needs the toolbox open (to be populated)
    componentEditNeedsToolbox = false;
    // drilled INTO a Group: its children are edited exactly like scene items (layers, toolbox, layout panel)
    groupEditMode = false;
    // false for a playlist-page player (no Layout - it fills its slot) -> the layout panel is hidden
    selectedItemHasLayout = true;
    componentEditTarget: { sceneId: any, componentId: any, regionWidth?: any, regionHeight?: any, needsToolbox?: boolean, fitComponent?: boolean, groupEdit?: boolean } | null = null;
    private realScene: IPlayerProps = null;

    private applyEffectiveSceneData() {
        if (!this.realScene) return;
        if (this.componentEditTarget && this.componentEditTarget.sceneId == this.realScene.Player.$.id) {
            const t = this.componentEditTarget;
            const region = (t.regionWidth && t.regionHeight) ? { width: t.regionWidth, height: t.regionHeight } : undefined;
            const wrapper = buildComponentWrapperScene([this.realScene], t.sceneId, t.componentId, region, t.fitComponent, t.groupEdit);
            this.sceneData = wrapper || this.realScene;
        } else {
            this.sceneData = this.realScene;
        }
        this.cd.detectChanges();
    }

    ngOnInit() {
        // Set editor mode to scene-builder (regular scene editor)
        this.storeSelector.dispatch(actionSetEditorMode({ editorMode: "scene-builder" }));

        this.setSceneOpacity();
        this.isHostDevOrLocal = isHostDevOrLocal();
        this.scriptingMode = isTruthy(this.localStoreService.getStorageValConfig("scriptingMode"));
        this.transitionsEnabled = convertNumberToBoolean(this.localStoreService.getStorageValConfig("transitionsEnabled"));

        this.cod(
            this.storeSelector.getLocalStoreUpdates("ILocalStorageConfig").subscribe((e) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig("experienceLevel"); // Alon
                this.iotEnabled = this.localStoreService.getStorageValConfig("iotEnabled") ?? "1";
            }),
        );

        // A viewer toolbar (e.g. the playlist editor's "open in dialog" button) asked to open a block's
        // property-grid table dialog, but that table lives in the lazy property panel and hasn't registered
        // yet. Show the details tab and expand the top panel so the block's table-list-input mounts; the
        // pending open then fires automatically (see TableDialogService.requestOpen).
        this.cod(
            this.tableDialogService.onMountRequest().subscribe(() => {
                if (this.activeTemplate !== "details") this.activeTemplate = "details";
                if (this.minimized) this.onMaximized();
                this.cd.detectChanges();
                setTimeout(() => this.propPanel?.open(), 0);
            }),
        );

        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            }),
        );
        this.cod(
            this.storeSelector.getResources().subscribe((i_resources) => {
                this.resources = i_resources;
            }),
        );
        this.cod(
            this.storeSelector.getUser().subscribe((i_user: IUser) => {
                this.user = i_user;
            }),
        );
        this.cod(this.storeSelector.getCoreData().subscribe((i_coreData: IAppSettingsWrap) => (this.coreAppData = i_coreData)));

        this.cod(
            this.storeSelector.getSceneBreadcrumbs().subscribe((breadcrumbs) => {
                this.breadcrumbs = breadcrumbs || [];
                this.cd.markForCheck();
            }),
        );

        // The URL param is the ROOT scene (direct open from the list / recent scenes, or browser
        // back-forward between roots). Select it - which drives the render stream below - and, when it is a
        // genuinely new root (not already part of the current drill trail), reset the breadcrumb path so a
        // fresh root starts a fresh trail. Drilling into nested scenes goes through
        // SceneService.enterNestedScene and does NOT touch the URL, so this fires only for real root
        // navigations: the browser back button moves between roots, while the breadcrumb back-arrow moves
        // within a single root's path. (Touch/slider drills DO route, but they push their crumb first, so
        // the incoming id is already in the trail and the path is preserved.)
        //
        // Combined with listenScenes so we only announce the selection AFTER the root scene has actually
        // loaded - dispatching a selected-scene-id for a scene not yet in the store makes downstream
        // consumers (the SignLib player) read scene data that isn't there yet. Guarded to fire once per new
        // root so later scene-array updates (e.g. an edit/save while drilled in) don't reset the selection
        // back to the root.
        // Browser back/forward navigates the URL between root scenes - reset the drill path so the trail
        // starts fresh at the root we land on (matches a page refresh, which begins from an empty store).
        // In-app drills keep the URL on the root and never trigger a navigation, so this only fires for
        // genuine history moves. Fires BEFORE the route param updates, so the route subscription below then
        // re-selects the landed-on root against the now-empty trail.
        this.cod(
            this.router.events
                .pipe(filter((e): e is NavigationStart => e instanceof NavigationStart && e.navigationTrigger === "popstate"))
                .subscribe(() => {
                    this.lastRootSceneId = null;
                    this.storeSelector.dispatch(actionSceneBreadcrumbsClear());
                }),
        );

        this.cod(
            combineLatest([this.route.paramMap, this.storeSelector.listenScenes()]).subscribe(([routeParams, i_scenes]) => {
                const rootId = routeParams.get("id");
                if (!rootId || this.lastRootSceneId === rootId) return;
                const exists = i_scenes.some((s: IPlayerProps) => s.Player.$.id === rootId);
                if (!exists) return; // wait until the root scene is in the store
                this.lastRootSceneId = rootId;
                const inTrail = (this.breadcrumbs || []).some((c) => String(c.sceneId) === String(rootId));
                if (!inTrail) {
                    this.storeSelector.dispatch(actionSceneBreadcrumbsClear());
                }
                this.storeSelector.dispatch(actionSelectedSceneId({ id: rootId }));
            }),
        );

        // this.cod(
        //     this.storeSelector.getScenes().subscribe((i_scenes) => {
        //         this.scenes = i_scenes;
        //     })
        // );
        // this.cod(
        //     this.route.paramMap.subscribe((routeParams) => {
        //         this.selectedSceneId = routeParams.get('id');
        //     })
        // );

        this.cod(
            this.storeSelector.listenSelectedSceneItemId().subscribe((value) => {
                this.selectedSceneItemId = value;
                this.visibility = "hidden";
            }),
        );
        this.cod(
            this.storeSelector.listenPlayerDataOfSelectedSceneItemId().subscribe((i_sceneSlice: ISceneTreeSliceResults) => {
                this.sceneSlice = i_sceneSlice;
                // a player embedded as a playlist page carries NO Layout - it fills its slot. There is then
                // nothing for the layout panel to edit (and block-layout-common-props reads Data[0].Layout[0]
                // unconditionally), so the panel is hidden for it.
                // A group always has a layout to edit (its design size in the <Group> node), even when used as a
                // playlist PAGE - where its outer Layout is stripped (a page fills its slot). Without this the
                // layout panel would hide when drilling into such a group, leaving no way to set its design size.
                this.selectedItemHasLayout = !!i_sceneSlice.sceneItem?.Data?.[0]?.Layout || isGroupItem(i_sceneSlice.sceneItem);
                this.loadInitEvents();
                this.loadEventRules();
                this.blockName = this.sceneSlice.sceneItem.$.label;
                if (compareIds(this.sceneSlice.sceneItem.$.player, BlockLabels.BLOCKCODE_SCENE.id)) {
                    this.blockName = "scene";
                } else {
                    this.blockName = !!this.blockName ? this.blockName.toString() : "";
                    this.blockName = shortenString(this.blockName.toLocaleLowerCase(), 30);
                }
                this.showEffects = !(compareIds(this.sceneSlice.sceneItem.$.player, BlockLabels.MUSICLIST.id) || compareIds(this.sceneSlice.sceneItem.$.player, BlockLabels.MUSIC.id));
                const sceneBlock = this.storeSelector.getBlockLabelById(this.sceneSlice.sceneItem.$.player);
                this.showEvents = false;
                if (!sceneBlock) return;
                this.showEvents = sceneBlock.advEvents.send === true || sceneBlock.advEvents.receive === true || sceneBlock.advEvents.filter === true || sceneBlock.advEvents.source === true;
                const d = this.sceneSlice.sceneItem?.Data?.[0];
                const gaugeDataSource = d?.Gauge?.[0]?.$?.dataSource || (d?.Gauge ? 'standalone' : undefined);
                const knobDataSource = d?.Knob?.[0]?.$?.dataSource || (d?.Knob ? 'standalone' : undefined);
                const bulbDataSource = d?.Bulb?.[0]?.$?.dataSource || (d?.Bulb ? 'standalone' : undefined);
                const colorControlDataSource = d?.ColorControl?.[0]?.$?.dataSource || (d?.ColorControl ? 'standalone' : undefined);
                const textInputDataSource = d?.TextInput?.[0]?.$?.dataSource || (d?.TextInput ? 'standalone' : undefined);
                const sliderDataSource = d?.Slider?.[0]?.$?.dataSource || (d?.Slider ? 'standalone' : undefined);
                const stepperDataSource = d?.Stepper?.[0]?.$?.dataSource || (d?.Stepper ? 'standalone' : undefined);
                const switchDataSource = d?.Switch?.[0]?.$?.dataSource || (d?.Switch ? 'standalone' : undefined);
                const checkDataSource = d?.Check?.[0]?.$?.dataSource || (d?.Check ? 'standalone' : undefined);
                const radioDataSource = d?.Radio?.[0]?.$?.dataSource || (d?.Radio ? 'standalone' : undefined);
                const jsonItemDataSource = d?.XmlItem?.[0]?.$?.dataSource || (d?.XmlItem ? 'standalone' : undefined);
                if (gaugeDataSource === 'provider' || knobDataSource === 'provider' || bulbDataSource === 'provider' || colorControlDataSource === 'provider' || textInputDataSource === 'provider' || sliderDataSource === 'provider' || stepperDataSource === 'provider' || switchDataSource === 'provider' || checkDataSource === 'provider' || radioDataSource === 'provider' || jsonItemDataSource === 'provider') {
                    this.showEvents = false;
                }
                if (gaugeDataSource === 'standalone' || knobDataSource === 'standalone' || colorControlDataSource === 'standalone' || textInputDataSource === 'standalone' || sliderDataSource === 'standalone' || stepperDataSource === 'standalone' || switchDataSource === 'standalone' || checkDataSource === 'standalone' || radioDataSource === 'standalone' || jsonItemDataSource === 'standalone') {
                    this.showEvents = false;
                }
                const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneSlice.sceneItem);
                const blockLabelProps: IBlockLabelProp = this.storeSelector.getBlockLabelById(playerId);
                this.isDataProvider = blockLabelProps.dataProviderBlock && blockLabelProps.dataProviderBlock === true;
                this.isBlockBeacon = compareIds(playerId, this.storeSelector.blockLabels.BEACON.id);
                this.isBlockCollection = compareIds(playerId, this.storeSelector.blockLabels.COLLECTION.id);
                this.isCollectionSlideshow = this.isBlockCollection &&
                    this.sceneSlice?.sceneItem?.Data?.[0]?.Collection?.[0]?.$?.mode === 'slideshow';
                this.isSceneButNotNested = this.blockName === "scene" && !this.sceneSlice.sceneItem.$.src;
                this.isNotNested = this.blockName === "scene" ? this.isSceneButNotNested : true;
                this.isPlayerAssignable = this.isSceneButNotNested && this.sceneSlice.sceneItem.$?.mimeType === SceneMimeTypes.Player;
                this.isBlockTransition = sceneBlock.transitions;
                this.isBlockAnimation = sceneBlock.animation;
                this.isBlockAdvEvents = sceneBlock.advEvents;
                this.isBlockEventsPremium = !!sceneBlock.eventsPremium;
                this.showPop = sceneBlock.pop;
                // this.isAnchorSupport = sceneBlock.anchor;

                this.setTitle();
                this.assignIcon(playerId, sceneBlock.types, sceneBlock.jsonItemBased);
                this.setBlockJsonBased();
            }),
        );

        this.cod(
            this.storeSelector
                .listenSelectedSceneIdAndSceneItemId()
                .pipe(
                    mergeMap((v: ISelectedSceneSceneId) => {
                        /** improve performance, if sceneMime is already set no need to check again **/
                        if (this.sceneMime) {
                            return of(null);
                        } else {
                            return this.storeSelector.getSceneMimeType(v.sceneId);
                        }
                    }),
                )
                .subscribe((v) => {
                    if (!v) return;
                    this.sceneMime = v;
                }),
        );

        // Render stream is keyed on the STORE's selected-scene-id, NOT the URL. Drilling into a nested scene
        // dispatches the child id (SceneService.enterNestedScene) so the canvas follows it while the URL
        // stays on the root; a root open / browser-back sets the id from the URL param (subscription above).
        this.cod(
            combineLatest([this.storeSelector.listenSelectedSceneId(), this.storeSelector.listenScenes()])
                .pipe(
                    map(([selectedId, i_scenes]) => {
                        return i_scenes.find((i_scene: IPlayerProps) => i_scene.Player.$.id === selectedId);
                    }),
                )
                .subscribe((i_scene: IPlayerProps) => {
                    if (!i_scene) return;
                    this.realScene = i_scene;
                    this.applyEffectiveSceneData();
                    if (this.selectedSceneId && this.selectedSceneId != i_scene.Player.$.id) {
                        this.renderSceneContainer = false;
                        this.cd.detectChanges();

                        setTimeout(() => {
                            this.renderScene(i_scene.Player.$.id);
                        }, 1000);
                    } else {
                        this.renderScene(i_scene.Player.$.id);
                    }
                }),
        );
        this.cod(
            this.containerService.editorMode.subscribe((mode: ITimelineViewMode) => {
                if ((mode == "playlistMode" || mode == "collectionMode") && this.selectedSceneItemId) {
                    this.containerService.playlist = {
                        sceneId: this.selectedSceneId,
                        selectedPlaylistId: this.selectedSceneItemId,
                    };
                    this.viewMode = mode;
                } else if (mode == "locationMode" && this.selectedSceneItemId) {
                    this.viewMode = mode;
                } else {
                    if (this.viewMode) {
                        // this.activeTabIndex = 2;
                    }
                    this.viewMode = null;
                }
            }),
        );
        this.cod(
            this.accessService.getGroupsTable("SignStudio Editor", "player_data").subscribe((v) => {
                this.accessConfig = v;
            }),
        );
        this.cod(
            this.containerService.getActiveSceneItemIds().subscribe((v) => {
                if (v && v.length > 1) {
                    this.multiple = true;
                    this.activeIds = v;
                    if (this.activeTabIndex == 3) {
                        // this.activeTabIndex = 2;
                    }
                } else {
                    this.multiple = false;
                    this.activeIds = [this.selectedSceneId];
                }
            }),
        );

        this.cod(
            this.aiService.selectPropertyPage$.subscribe((propertyPage) => {
                this.setActiveTemplate(propertyPage);
            }),
        );

        this.cod(
            this.containerService.componentEditTarget.subscribe((target) => {
                this.componentEditTarget = target;
                this.componentMode = !!target;
                this.componentEditNeedsToolbox = !!target?.needsToolbox;
                this.groupEditMode = !!target?.groupEdit;
                this.applyEffectiveSceneData();
                // the left toolbox shows/hides with the mode -> nudge the drawer to recompute content
                // margins. This early attempt can race the drawer's open/close animation, so the reliable
                // recompute happens on the drawer's openedChange (see ngAfterViewInit).
                setTimeout(() => this.drawerContainer?.updateContentMargins(), 200);
            }),
        );
    }

    ngAfterViewInit() {
        // When leaving focused component-edit mode the toolbox drawer re-opens, but MatDrawerContainer
        // does not always recompute the content margin in time -> the canvas (and its left/vertical ruler)
        // stays shifted left, sliding under the re-shown toolbox so the ruler appears to vanish. The drawer's
        // openedChange fires once its open/close animation has settled, which is the correct moment to force
        // the margin recompute (a following frame catches any late content-width settle).
        this.cod(
            this.toolboxDrawer?.openedChange.subscribe(() => {
                this.drawerContainer?.updateContentMargins();
                requestAnimationFrame(() => this.drawerContainer?.updateContentMargins());
            }),
        );

        this.watchToolbarHeight();
        this.watchBreadcrumbActions();

        // The editor toolbar is scene-builder's template rendered here as an embedded view, so scene-builder's
        // own markForCheck() can't refresh it (different CD tree). When scene-builder changes a toolbar-relevant
        // field (e.g. experienceLevel loaded async from localStorage, which gates the visibility/guides/background
        // groups + the move-scene button), it pings containerService.toolbarRefresh; re-check the bar here so the
        // groups appear immediately instead of only after the next unrelated CD tick (previously: a window resize).
        this.cod(
            this.containerService.toolbarRefresh.subscribe(() => this.cd.detectChanges()),
        );
    }

    // The relocated editor toolbar can wrap onto a second line when the window is narrow, making it taller than
    // its 46px baseline. The nav/toolbox panels are sized with `calc(100vh - <fixed>)` that bakes in a one-line
    // toolbar, so the extra line pushed their content past the viewport and produced a second, wrong scrollbar.
    // Publish the toolbar's EXTRA height (beyond 46px) as the `--editor-toolbar-extra` CSS variable so those
    // calcs can subtract it. When the toolbar is a single line the value is 0px, so nothing changes.
    private watchToolbarHeight() {
        const BASELINE = 46;
        const root = document.documentElement;
        const apply = () => {
            const el = document.querySelector('.scene-tool-bar1') as HTMLElement | null;
            // Height for the panel `calc()`s. When collapsed the bar is clamped to one row (max-height in scss),
            // so this reads BASELINE and the panels below reclaim the space automatically.
            const h = el ? el.getBoundingClientRect().height : BASELINE;
            const extra = Math.max(0, Math.round(h) - BASELINE);
            root.style.setProperty('--editor-toolbar-extra', extra + 'px');

            // Does the bar actually wrap onto a 2nd+ line at this width? Measure the group boxes' row offsets
            // (not the bar height — while collapsed the bar is clamped, but the wrapped groups keep their real
            // offsetTop because overflow:hidden clips paint, not layout). Ignore display:none groups
            // (offsetParent === null). > 4px spread between the topmost and bottommost group means 2+ rows.
            let wrapped = false;
            if (el) {
                const tops = Array.from(el.querySelectorAll<HTMLElement>('.toolbar-group'))
                    .filter(g => g.offsetParent !== null)
                    .map(g => g.offsetTop);
                if (tops.length) wrapped = (Math.max(...tops) - Math.min(...tops)) > 4;
            }
            if (this.containerService.toolbarWrapped.value !== wrapped) {
                this.containerService.toolbarWrapped.next(wrapped);
            }
        };

        const ro = new ResizeObserver(() => apply());
        // Re-attach whenever the toolbar template is (re)published into the shell, and recompute immediately.
        this.cod(
            this.containerService.toolbarTemplate.subscribe(() => {
                requestAnimationFrame(() => {
                    ro.disconnect();
                    const el = document.querySelector('.scene-tool-bar1');
                    if (el) ro.observe(el);
                    // Also observe the inner groups container: while the bar is COLLAPSED its outer height is
                    // clamped (max-height), so adding groups — e.g. experienceLevel loading its advanced groups —
                    // wouldn't resize .scene-tool-bar1 and the observer would miss the new 2nd line. The groups
                    // container is unclamped, so its height still grows with the row count and fires the recompute.
                    const groupsEl = el?.querySelector('.toolbar-groups');
                    if (groupsEl) ro.observe(groupsEl);
                    apply();
                });
            }),
        );
        // Ensure the observer + the CSS variable are cleaned up on destroy.
        // cod() calls non-Subscriber entries as functions, so register a plain
        // cleanup function (a bare Subscription is neither a Subscriber nor
        // callable, which crashed ngOnDestroy with "f is not a function").
        this.cod(() => {
            ro.disconnect();
            root.style.removeProperty('--editor-toolbar-extra');
        });
    }

    // The preview + register actions sit at the right of the breadcrumb bar WITH text labels. As the window
    // (or a side panel) narrows, we want the LABELS to be the first thing sacrificed — dropped to icon-only —
    // BEFORE the breadcrumb trail is forced to shrink/ellipsize. A viewport media query can't express that: the
    // point where the trail starts squeezing depends on the trail's own length, the open panels and the drill
    // depth, none of which map to a fixed screen width. So measure it live.
    //
    // Both the trail and the actions slot are flex-shrink:0 (see scss), so an over-full labeled row OVERFLOWS
    // the bar (bar.scrollWidth > clientWidth) instead of quietly shrinking the trail. We detect that overflow
    // in the labeled state and compact the actions to icon-only, which frees the width — so the buttons yield
    // first and the trail keeps its natural size until there's genuinely no room even for icons.
    private watchBreadcrumbActions() {
        const measure = () => {
            const bar = document.querySelector('.scene-breadcrumbs-bar') as HTMLElement | null;
            const slot = bar?.querySelector('.breadcrumb-actions-slot') as HTMLElement | null;
            if (!bar || !slot) return;

            // Measure the LABELED state: removing .compact then reading scrollWidth forces a synchronous reflow,
            // so we see whether the full-label row overflows the bar. If it does we re-add .compact below — the
            // transient never paints (all synchronous, no net size change when it stays compact), so there's no
            // flicker and no ResizeObserver feedback loop.
            slot.classList.remove('compact');
            if (bar.scrollWidth - bar.clientWidth > 1) slot.classList.add('compact');
        };

        const ro = new ResizeObserver(() => requestAnimationFrame(measure));
        // (Re)attach whenever the actions template is published into the shell (the bar is torn down/rebuilt on
        // mode switches). Observe both the bar (window/panel resize) and the trail (drill in/out changes its
        // width without changing the bar's), then measure once immediately.
        this.cod(
            this.containerService.breadcrumbActionsTemplate.subscribe(() => {
                requestAnimationFrame(() => {
                    ro.disconnect();
                    const bar = document.querySelector('.scene-breadcrumbs-bar');
                    if (bar) {
                        ro.observe(bar);
                        const crumbs = bar.querySelector('.breadcrumbs-container');
                        if (crumbs) ro.observe(crumbs);
                    }
                    measure();
                });
            }),
        );
        this.cod(() => ro.disconnect());
    }

    onNavMaximized() {
        setTimeout(() => {
            this.drawerContainer.updateContentMargins();
        }, 200);
    }

    onNavMinimized(event) {
        setTimeout(() => {
            this.drawerContainer.updateContentMargins();
        }, 0);
    }

    // the last ROOT scene id we announced from the URL - guards the route subscription so it fires once
    // per new root (not on every scenes-array update, which would clobber a drill selection)
    private lastRootSceneId: string = null;

    // Render the given scene. Does NOT dispatch the selected-scene-id: the id arrives FROM the store's
    // selected-scene-id stream (set by the URL on a root open, or by drill/breadcrumb navigation), so
    // re-dispatching here would loop.
    private renderScene(newSceneId) {
        this.selectedSceneId = newSceneId;
        this.renderSceneContainer = true;
        this.cd.detectChanges();
    }

    private setSceneOpacity() {
        const sceneOpacityLevel = this.localStoreService.getStorageValConfig("sceneOpacityLevel") / 100;
        const sceneGuidelinesOpacityLevel = this.localStoreService.getStorageValConfig("sceneGuidelinesOpacityLevel") / 100;
        document.documentElement.style.setProperty("--scene-opacity", String(sceneOpacityLevel));
        document.documentElement.style.setProperty("--guidelines-opacity", String(sceneGuidelinesOpacityLevel));
    }

    private setTitle(i_default?) {
        if (i_default) return this.title.setTitle("SignStudio");
        if (compareIds(this.sceneSlice.sceneItem.$.player, BlockLabels.BLOCKCODE_SCENE.id)) {
            const title = this.sceneSlice.sceneItem.$.label;
            let mime = this.sceneSlice.sceneItem.$.mimeType ? mimeSwap("longToShort", this.sceneSlice.sceneItem.$.mimeType) : "editor";
            if (!mime) mime = "custom";
            this.title.setTitle(`${title} | ${mime}`);
        }
    }

    assignIcon(i_blockPlayerId, sceneItemMimeType, isBlockItemBased) {
        if (sceneItemMimeType && isBlockItemBased && sceneItemMimeType?.length > 0 && isMimeTypeExists(sceneItemMimeType, this.sceneMime)) {
            this.blockIcon = getFontIcons({ $: { id: this.sceneMime } }).icon;
        } else {
            this.blockIcon = getFontIcons({ $: { id: i_blockPlayerId } }).icon;
        }
        this.blockMimeName = getFontIcons({ $: { id: i_blockPlayerId } }).name;
        this.blockVideoLinkName = this.storeSelector.getBlockLabelById(this.sceneSlice.sceneItem.$.player).name;
        // this.blockMimeName = i_blockPlayerId.replace(/Json./ig, '').toLowerCase();
        // this.blockMimeName = this.blockMimeName.charAt(0).toUpperCase() + this.blockMimeName.slice(1);

        // A migrated SWF/FLV stays an Image block (3130) so the legacy player renders the original, but
        // block-loader opens the Video editor when its resource points forward to a converted VIDEO
        // (webm/mp4). Match the header: relabel this Image block as Video only when the converted resource is a
        // video (a png-converted SWF stays an Image).
        const imageId = this.storeSelector.blockLabels.IMAGE.id;
        const videoId = this.storeSelector.blockLabels.VIDEO.id;
        if (String(i_blockPlayerId) === String(imageId)) {
            const resId = this.sceneSlice?.sceneItem?.Data?.["0"]?.Resource?.["0"]?.$?.resource;
            if (resId != null) {
                this.storeSelector.getConvertedResourceType(resId).pipe(take(1)).subscribe((convType) => {
                    if (convType === "webm" || convType === "mp4" || convType === "m4v" || convType === "m3u8") {
                        this.blockIcon = getFontIcons({ $: { id: videoId } }).icon;
                        this.blockMimeName = getFontIcons({ $: { id: videoId } }).name;
                        this.cd.detectChanges();
                    }
                });
            }
        }
    }

    toggleMinimize() {
        if (!this.sidenav.opened) {
            const container = document.querySelector(".list-container.main-container");
            if (container) {
                super.toggleSlide(container.clientWidth);
            }
        }
        this.sidenav.toggle();
        this.cd.detectChanges();

        // setTimeout(() => {  // used to prevent toolbar broken style
        //     this.propsMinimized = propsMinimized;
        // });
    }

    backSceneList() {
        // if (this.saveMode.saveSceneOnExit) {
        //     this.onSave(() => {}, false);
        // }
        this.containerService.setMarkedTableRow(this.selectedSceneId);
        this.router.navigateByUrl("/editor/list");
    }

    private setBlockJsonBased() {
        const blockLabelProps: IBlockLabelProp = this.storeSelector.getBlockLabelById(this.sceneSlice.sceneItem.$.player);
        this.videoHelp = blockLabelProps.videoHelp;
        this.blockJsonBased = blockLabelProps.types.length > 0 && blockLabelProps?.jsonPlayerBased;
        if (_.isUndefined(this.blockJsonBased)) this.blockJsonBased = false;
    }

    animationDone(e) {
        if (e.toState === "hidden") {
            this.visibility = "visible";
        }
    }

    onClickTab(e) {
        // if (this.sceneButNotNested) {
        //     this.activeTabIndex = e;
        // } else {
        //     this.activeTabIndex = e + 1;
        // }
    }

    // private isDataProvider(sceneItemPlayer) {
    //     if (DataProviderBlocks.findIndex((b) => compareIds(sceneItemPlayer, b.id))) {
    //         return true;
    //     }
    //     return false;
    // }

    toggleTransitions() {
        this.transitionsEnabled = !this.transitionsEnabled;
        this.localStoreService.setStorageValConfig("transitionsEnabled", this.transitionsEnabled);
    }

    onMinimized() {
        this.minimized = true;
        setTimeout(() => {
            this.drawerContainer.updateContentMargins();
        }, 200);
    }

    onMaximized() {
        this.minimized = false;
        setTimeout(() => {
            this.drawerContainer.updateContentMargins();
        }, 200);
    }

    setActiveTemplate(templateName: string): void {
        if (this.activeTemplate != templateName) {
            this.onMaximized();
        } else {
            if (this.minimized) {
                this.onMaximized();
            } else {
                this.onMinimized();
            }
        }
        this.activeTemplate = templateName;
    }

    getTemplate(name: string): TemplateRef<any> | null {
        switch (name) {
            case "details":
                return this.detailsTemplate;
            case "animation":
                return this.animationTemplate;
            case "effects":
                return this.effectsTemplate;

            default:
                return null;
        }
    }

    protected override toggleSlideOnResize() {
        this.sidenavMode = "side";
        if (window.innerWidth < this.toggleWidth) {
            this.onMinimized();
        } else {
            this.onMaximized();
        }
    }

    getSelectedItems() {
        if (!this.sceneData || !this.activeIds || this.activeIds.length === 0) {
            return [];
        }

        const players = this.sceneData.Player?.Data?.[0]?.Scene?.[0]?.Players?.[0]?.Player;
        if (!players) {
            return [];
        }

        return this.activeIds
            .map((activeId) => {
                const player = players.find((p) => compareIds(p.$.id, activeId));
                if (!player) return null;

                const block = this.storeSelector.getBlockLabelById(player.$.player);
                if (!block) return null;

                const blockIcon = getFontIcons({ $: { id: player.$.player } }).icon;
                const itemName = this.getSelectedItemName(player);

                return {
                    id: player.$.id,
                    name: itemName,
                    icon: blockIcon,
                    mimeType: player.$.mimeType || "",
                };
            })
            .filter((item) => item !== null);
    }

    private getSelectedItemName(sceneItem: any): string {
        if (this.storeSelector.isResourceBased(sceneItem.$.player)) {
            const res = this.resources.find((r) => {
                return compareIds(r.resource_id, sceneItem.Data?.["0"]?.Resource?.["0"]?.$?.resource);
            });
            if (res) {
                return res.resource_name;
            } else {
                return sceneItem.$.label;
            }
        } else {
            return sceneItem.$.label;
        }
    }

    deselectAll() {
        // Deselect all items and select the root scene
        if (this.selectedSceneId) {
            this.storeSelector.dispatch(actionSelectedSceneItemId({ id: this.selectedSceneId }));
            this.containerService.activeSceneItemIds.next([this.selectedSceneId]);
        }
    }

    override destroy() {
        super.destroy();
        this.storeSelector.dispatch(actionSelectedSceneItemId({ id: null }));
        this.storeSelector.dispatch(actionSelectedSceneId({ id: null }));
        this.storeSelector.dispatch(actionSceneBreadcrumbsClear());
        this.storeSelector.dispatch(actionSceneJumpLinked({ previousLinkedSceneId: null, previousSlidesSceneId: null }));
        this.storeSelector.dispatch({ type: "CLEAR" });
        this.containerService.updateComponentEditTarget(null);
        this.containerService.updateEditorMode(null);
        this.setTitle(true);
    }

    // --- Init Events ---

    private _initEvents: any[] = [];
    selectedInitEventIndex = -1;
    private _initEventsEditing = false;
    initEventsHighlightedRows: any[] = [];
    initEventsButtons: IButtonBar[] = [
        { callBack: v => v, icon: 'add', name: 'add', disableByList: false, disabled: false, tooltip: '+' },
        { callBack: v => v, icon: 'remove', name: 'remove', disableByList: true, disabled: false, tooltip: '-' }
    ];
    private _eventRules: any[] = [];
    selectedEventRuleIndex = -1;
    private _eventRulesEditing = false;
    eventRulesDataSource = new MatTableDataSource<any>([]);
    eventRulesHighlightedRows: any[] = [];
    eventRulesButtons: IButtonBar[] = [
        { callBack: v => v, icon: 'add', name: 'add', disableByList: false, disabled: false, tooltip: '+' },
        { callBack: v => v, icon: 'remove', name: 'remove', disableByList: true, disabled: false, tooltip: '-' }
    ];

    private loadInitEvents(): void {
        if (!this.sceneSlice?.sceneItem) return;
        if (this._initEventsEditing) return;
        const data = this.sceneSlice.sceneItem.Data?.[0] as any;
        this._initEvents = JSON.parse(JSON.stringify(data?.InitEvents || []));
        this.initEventsDataSource.data = this._initEvents;
    }

    // "free-limited" components (e.g. Collection): addable on Free, but the events panel is gated. When
    // locked, the events accordion shows an "upgrade to use feature" button and its controls are disabled.
    get eventsLocked(): boolean {
        return Lib.IsEventAddBlocked({eventsPremium: this.isBlockEventsPremium} as any, this.user);
    }

    upgradeEvents(): void {
        this.appService.openWizardUpgradeDialog();
    }

    addInitEvent(): void {
        if (!Array.isArray(this._initEvents)) this._initEvents = [];
        this.storeSelector.getEventStrings().pipe(take(1)).subscribe(eventNames => {
            const dialogRef = this.dialog.open(EventPickerDialogComponent, {
                width: '500px',
                panelClass: 'custom-dlg-container',
                data: { mode: 'init', eventName: '', eventValue: '', eventNames }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (!result?.eventName) return;
                this._initEventsEditing = true;
                this._initEvents.push({ $: { eventName: result.eventName, eventValue: result.eventValue || '' } });
                this.selectedInitEventIndex = this._initEvents.length - 1;
                this.initEventsDataSource.data = this._initEvents.slice();
                this.cd.detectChanges();
                this.saveInitEvents();
            });
        });
    }

    editInitEvent(index: number): void {
        const event = this._initEvents[index];
        if (!event) return;
        this.storeSelector.getEventStrings().pipe(take(1)).subscribe(eventNames => {
            const dialogRef = this.dialog.open(EventPickerDialogComponent, {
                width: '500px',
                panelClass: 'custom-dlg-container',
                data: { mode: 'init', eventName: event.$.eventName, eventValue: event.$.eventValue, eventNames }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (!result?.eventName) return;
                event.$.eventName = result.eventName;
                event.$.eventValue = result.eventValue || '';
                this._initEventsEditing = true;
                this.initEventsDataSource.data = this._initEvents.slice();
                this.cd.detectChanges();
                this.saveInitEvents();
            });
        });
    }

    removeInitEvent(index: number): void {
        this._initEvents.splice(index, 1);
        this.selectedInitEventIndex = -1;
        this.initEventsDataSource.data = this._initEvents.slice();
        this.cd.detectChanges();
        this.saveInitEvents();
    }

    selectInitEvent(index: number): void {
        this.selectedInitEventIndex = index;
        this.initEventsHighlightedRows = [this._initEvents[index]];
    }

    removeSelectedInitEvent(): void {
        if (this.selectedInitEventIndex >= 0) {
            this.removeInitEvent(this.selectedInitEventIndex);
        }
    }

    onInitEventsChanged(): void {
        this._initEventsEditing = true;
        this.saveInitEvents();
    }

    private saveInitEvents(): void {
        const sceneId = this.sceneSlice?.sceneId || this.selectedSceneId;
        if (!sceneId) return;
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: String(sceneId),
            sceneItemId: String(sceneId),
            values: [{
                key: 'InitEvents',
                value: JSON.parse(JSON.stringify(this._initEvents)),
                storePath: 'Data.0'
            }]
        }));
        setTimeout(() => { this._initEventsEditing = false; }, 500);
    }

    // --- Event Rules ---

    private loadEventRules(): void {
        if (!this.sceneSlice?.sceneItem) return;
        if (this._eventRulesEditing) return;
        const data = this.sceneSlice.sceneItem.Data?.[0] as any;
        this._eventRules = JSON.parse(JSON.stringify(data?.EventRules || []));
        this.eventRulesDataSource.data = this._eventRules;
    }

    addEventRule(): void {
        if (!Array.isArray(this._eventRules)) this._eventRules = [];
        this.storeSelector.getEventStrings().pipe(take(1)).subscribe(eventNames => {
            const dialogRef = this.dialog.open(ExpressionBuilderDialogComponent, {
                width: '770px',
                maxHeight: '90vh',
                panelClass: 'custom-dlg-container',
                data: { expression: '', eventName: '', eventNames }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (!result?.eventName || !result?.expression) return;
                this._eventRulesEditing = true;
                this._eventRules.push({ $: { eventName: result.eventName, expression: result.expression } });
                this.selectedEventRuleIndex = this._eventRules.length - 1;
                this.eventRulesDataSource.data = this._eventRules.slice();
                this.cd.detectChanges();
                this.saveEventRules();
            });
        });
    }

    removeEventRule(index: number): void {
        this._eventRules.splice(index, 1);
        this.selectedEventRuleIndex = -1;
        this.eventRulesHighlightedRows = [];
        this.eventRulesDataSource.data = this._eventRules.slice();
        this.cd.detectChanges();
        this.saveEventRules();
    }

    removeSelectedEventRule(): void {
        if (this.selectedEventRuleIndex >= 0) {
            this.removeEventRule(this.selectedEventRuleIndex);
        }
    }

    selectEventRule(index: number): void {
        this.selectedEventRuleIndex = index;
        this.eventRulesHighlightedRows = [this._eventRules[index]];
    }

    editEventRuleExpression(index: number): void {
        const rule = this._eventRules[index];
        if (!rule) return;
        this.storeSelector.getEventStrings().pipe(take(1)).subscribe(eventNames => {
            const dialogRef = this.dialog.open(ExpressionBuilderDialogComponent, {
                width: '770px',
                maxHeight: '90vh',
                panelClass: 'custom-dlg-container',
                data: { expression: rule.$.expression, eventName: rule.$.eventName, eventNames }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (!result?.eventName || !result?.expression) return;
                rule.$.eventName = result.eventName;
                rule.$.expression = result.expression;
                this._eventRulesEditing = true;
                this.eventRulesDataSource.data = this._eventRules.slice();
                this.cd.detectChanges();
                this.saveEventRules();
            });
        });
    }

    onEventRulesChanged(): void {
        this._eventRulesEditing = true;
        this.saveEventRules();
    }

    private saveEventRules(): void {
        const sceneId = this.sceneSlice?.sceneId || this.selectedSceneId;
        if (!sceneId) return;
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: String(sceneId),
            sceneItemId: String(sceneId),
            values: [{
                key: 'EventRules',
                value: JSON.parse(JSON.stringify(this._eventRules)),
                storePath: 'Data.0',
                preProcessFunction: (newValues, draft, action, sceneTreeSlice) => {
                    if (sceneTreeSlice?.sceneItem?.Data?.[0]) {
                        sceneTreeSlice.sceneItem.Data[0][newValues.key] = newValues.value;
                    }
                }
            }]
        }));
        setTimeout(() => { this._eventRulesEditing = false; }, 500);
    }
}
